import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'

$(document).on ('turbolinks:load', () => {
  
  // datepicker 表示設定
  var period = $('#params').data('period')
  var filter = $('#params').data('filter')
  var selected_type = $('#params').data('selected-type')
  var calFormat = "Y/m/d"
  var defDate = new Date($('#params').data('year'), $('#params').data('month')-1, $('#params').data('mday'))
  var plugins = []
  if (period == 'monthly') {
    calFormat = "Y/m"
    defDate = new Date($('#params').data('year'), $('#params').data('month')-1)
    plugins = [
      new monthSelectPlugin({
        shorthand: true
      })
    ]
  }


  // showの設定
  function changeDate (selectedDates, dateStr, instance) {
    var dt = selectedDates[0]
    var year = dt.getFullYear()
    var month = dt.getMonth() + 1
    var mday = dt.getDate()

    var params = `?filter=${filter}&period=${period}&selected_type=${selected_type}`

    if (filter == 'mach') {
      var mid = $('#params').data('mid')
      params += `&mid=${mid}`
    } else if (filter == 'shop') {
      var sid = $('#params').data('sid')
      params += `&sid=${sid}`
    }
    params += `&year=${year}`
    if (period == 'monthly') {
      params += `&month=${month}`
    } else if (period == 'daily') {
      params += `&month=${month}&mday=${mday}`
    }
    window.location.href = location.pathname + params
  }

  if (!$("#date_picker").hasClass('flatpickr-input')) {
    flatpickr($("#date_picker"), {
      dateFormat: calFormat,
      locale: 'ja',
      defaultDate: defDate,
      inline: true,
      clickOpens: false,
      onChange: changeDate,
      plugins: plugins
    })
  }
})

$(document).on ('ajax:error', '#sales_amount_edit_form', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#sales_amount_edit_form')
  alert = '<div id="sales-amount-error" class="alert alert-danger alert-dismissable" role="alert">'
  alert = alert + '<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>'
  $.each(data.errors, (idx, msg) => {
    alert = alert + `<strong>・${msg}</strong><br>`
  })
  alert = alert + '</div>'

  if ($('#sales-amount-error')[0]) {
    $('#sales-amount-error').remove()
    form.prepend(alert)
  } else {
    form.prepend(alert)
  }
})
